import classNames from 'classnames'
import { forwardRef, useCallback, useImperativeHandle, useRef } from 'react'
import ModalPortal from './ModalPortal'
import styles from './Scrim.module.scss'
import type { BackdropProps } from './types'

const Scrim = forwardRef(function MyInput(props: BackdropProps, ref) {
  const { children, onClick, className } = props
  const localRef = useRef<HTMLDivElement>(null)
  const handleClick = useCallback(() => {
    onClick && onClick()
  }, [onClick])

  useImperativeHandle(
    ref,
    () => ({
      startClosing() {
        localRef?.current?.classList.add(styles['pintxo-backdrop--closing'])
      },
    }),
    []
  )

  return (
    <ModalPortal>
      <div
        aria-label="backdrop"
        className={classNames(styles['pintxo-backdrop'], className)}
        onClick={handleClick}
        ref={localRef}
      >
        {children}
      </div>
    </ModalPortal>
  )
})
Scrim.displayName = 'Scrim'
export default Scrim
